<template>
    <div>
        产品业务知识库，开发中，即将上线。
    </div>

</template>

<script>
    export default {
        name: "PordKnowledge",
        data() {
            return {
            }
        },
        mounted() {
        },
        methods: {
        }
    }
</script>

<style>

</style>
